// extracted by mini-css-extract-plugin
export default {"tooltip":"ZU-z","arrow":"_U-z"};